import {useParams} from 'react-router-dom';
import LibraryBrowser from './Browser';

export default function LibrarySection() {
    const {id, page} = useParams();
    const sectionId = Number.parseInt(String(id || ''), 10) || null;
    const routePage = Number.parseInt(String(page || '1'), 10) || 1;

    return (
        <LibraryBrowser
            sectionId={sectionId}
            routePage={routePage}
            topAdvertiseUnit="libraryPage1"
            sidebarAdvertiseUnit="libraryPage2"
        />
    );
}
